module.exports = __webpack_public_path__ + "img/music.14e022cc.svg";